import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { useDrag, useDrop } from 'react-dnd'

import DragIcon from '@SonarCX/components/icons/DragIcon'
import { FavoriteCardProps } from '..'

import useStyles from '../styles'

const ITEM_TYPE = 'FAVORITE'

const DraggableContainer: React.FC<
  PropsWithChildren<Partial<FavoriteCardProps>>
> = ({ favorite, draggable, handleMoveFavorite, children }) => {
  const [{ opacity }, dragRef, previewRef] = useDrag({
    item: { type: ITEM_TYPE, id: favorite.item_id },
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.8 : 1,
      dragging: !!monitor.isDragging()
    })
  })

  const [{ isOver: isOverTop }, dropTop] = useDrop({
    accept: ITEM_TYPE,
    drop: (item: any) => handleMoveFavorite(item.id, favorite.item_id),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  })

  const classes = useStyles({
    isOverTop
  })

  return (
    <div className={classes.root} style={{ opacity }}>
      {draggable && (
        <div ref={dragRef} className={classes.drag}>
          <DragIcon style={{ paddingTop: 4 }} />
        </div>
      )}
      <div className={clsx(classes.drop, classes.dropTop)}>
        <div ref={dropTop} className={classes.dropTopZone}></div>
      </div>

      <div className={classes.childRoot} ref={previewRef}>
        {children}
      </div>
    </div>
  )
}

export default DraggableContainer
